import { AxtyreMotion } from "./AxtyreMotion";

document.addEventListener('DOMContentLoaded', function() {
    try {
        new AxtyreMotion();
        fetchFavoriteStore();
    } catch (error) {
        console.error(error);
    }
})

function fetchFavoriteStore() {
    if (typeof getCookie === "function") {
        var favorite_store = getCookie('favorite_store');
        if (favorite_store) {
            $.ajax({
                "url": ajaxUrl,
                "method": "GET",
                "data": { "action": "axtyremotion_update_fav_store", "id_store": favorite_store },
                "dataType": "json"
            }).done(function (response) {
                if (response.success && response.data !== "") {
                    $('#ajax-tyremotion-update').replaceWith(response.data);
                }
            });
        }
    }
}